/**
 * The two guest-provisioning strings rendered on BOTH deployables: the landing
 * CTAs in `apps/marketing` and `/start` in `apps/web` (the followed-link
 * fallback that provisions the same space). They must read identically, so the
 * strings live here and `modules/marketing/constants.ts` re-exports them.
 */
export const CTA_REASSURANCE = 'No signup, no credit card.';
export const HEADER_TRY_PENDING = 'Setting up your space...';
